export default {
  pessoa: {
    email: {
      value: '',
      maxlength: '70',
      required: false,
      state: null
    },
    nome: {
      value: '',
      maxlength: '70',
      required: false,
      state: null
    },
    document: {
      value: '',
      maxlength: '14',
      required: false,
      state: null
    },
    tipoPessoa: {
      value: '',
      options: [
        { value: 'PF', text: 'Pessoa Física' },
        { value: 'PJ', text: 'Pessoa Jurídica' }
      ],
      required: false,
      state: null
    },
    dataNascimento: {
      value: '',
      mask: '##/##/####',
      required: false,
      state: null
    },
    contaCorrente: {
      value: '',
      maxlength: '20',
      required: false,
      state: null
    },
    contaCapital: {
      value: '',
      maxlength: '20',
      required: false,
      state: null
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/employee/components/add/associate-form.js